import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import { ToolTipContainer, ToolTipIconBase } from './styles';

const onTooltipMouseEvent = e => {
  const eventType = e.type === 'mouseenter' ? 'focus' : 'blur';
  const event = new Event(eventType);
  e.target.dispatchEvent(event);
};

const onTooltipKeyPressEvent = e => {
  if (e.key === 'Escape') {
    const eventType = 'blur';
    const event = new Event(eventType);
    e.target.dispatchEvent(event);
  }
};

const ToolTipIcon = ({ children, ...props }) => (
  <ToolTipIconBase
    onMouseEnter={onTooltipMouseEvent}
    onMouseLeave={onTooltipMouseEvent}
    onKeyUp={onTooltipKeyPressEvent}
    {...props}
  >
    {children}
  </ToolTipIconBase>
);

const ToolTip = ({ tipData, labelId = '', children }) => {
  const intl = useIntl();

  const ariaLabel = `${intl.formatMessage({
    id: 'toolTip',
  })} ${intl.locale === 'fr' ? `${labelId} :` : `${labelId}:`} ${tipData}.`;

  const tooltipLabel = `${labelId.toLowerCase().split(' ').join('-')}-tooltip`;

  return (
    <ToolTipContainer>
      <ToolTipIcon
        data-tooltip-id={tooltipLabel}
        type="button"
        data-tooltip-html={tipData}
        aria-label={ariaLabel}
        aria-controls={tooltipLabel}
      >
        {children}
      </ToolTipIcon>
      <ReactTooltip
        id={tooltipLabel}
        multiline
        role="status"
        className="customTip"
        openEvents={{ mouseenter: true, focus: true, click: true }}
      />
    </ToolTipContainer>
  );
};

ToolTipIcon.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

ToolTip.propTypes = {
  children: PropTypes.string.isRequired,
  labelId: PropTypes.string,
  tipData: PropTypes.string.isRequired,
};

export default ToolTip;
